import script from "./LeagueDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LeagueDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./LeagueDetailView.vue?vue&type=style&index=0&id=1af2340c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af2340c"]])

export default __exports__